<template>
  <div class="mb-3" v-if="isShow()">
    <label class="form-label">Тема</label>
    <div class="row g-2" :class="{'is-invalid': fields.validator.color_id.$invalid && fields.validator.color_id.$dirty}">
      <div class="col-auto" v-for="(theme, key) in themes" :key="key">
        <label class="form-colorinput form-colorinput-light">
          <input name="color" type="radio" v-model="fields.payload.color_id" :value="theme.color_id" @change="onChange" class="form-colorinput-input"/>
          <span class="form-colorinput-color" :style="{'background-color': theme.color_code}"></span>
        </label>
      </div>
    </div>
    <div class="invalid-feedback" v-for="error of fields.validator.color_id.$silentErrors" :key="error.$uid">
      {{ error.$message }}
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import Api from "./services/Api"

export default defineComponent({
  name: "Theme",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive({
      validator: {},
      payload: {},
    })

    const themes = ref({})

    onMounted(async () => {
      disableShow()
      await initFields(props.data)
      await setThemes()
      enableShow()
    })

    watch(() => props.data, (val) => {
      initFields(val)
    })

    async function setThemes() {
      let resp = await Api.themes()

      let items = resp.data.items

      for (let key of Object.keys(items)) {
        let item = items[key]
        themes.value[key] = {
          "color_id": item["color_id"],
          "color_code": item["color_code"],
        }
      }
    }

    async function initFields(val) {
      fields.validator = val["validator"]
      fields.payload = val["payload"]
    }

    function disableShow() {
      show.value = false
    }

    function enableShow() {
      show.value = true
    }

    function onChange(e) {
      emit("onUpdate", {
        value: parseInt(e.target.value),
      })
    }

    function isShow() {
      return show.value === true
    }

    return {
      fields,
      themes,
      onChange,
      isShow,
    }
  }
})
</script>
